export interface ImpressaoCompraSelecao {
    nunota: number;
    view: string;
}
export type ModeloCompra =
    | 'PRE_COMPRA_BRL'
    | 'PRE_COMPRA_USD'
    | 'INTERNACIONAL'
    | 'LISTA_GERAL'
    | 'PEDIDO_COMPRA';
export interface ColunaCompra {
    chave: string;
    titulo: string;
    ingles?: string;
    formato?: 'numero' | 'valor';
    padrao?: boolean;
}
export interface ItemImpressaoCompra {
    [chave: string]: any;
    seq: any;
    status: any;
    fabricante: any;
    coreBrl: number | null;
}
export const MODELOS_COMPRA: Array<{
    view: string;
    modelo: ModeloCompra;
    titulo: string;
}> = [
    {
        view: 'impressao-pre-compra',
        modelo: 'PRE_COMPRA_BRL',
        titulo: 'Pré-Compra (Cotação) - Reais'
    },
    {
        view: 'impressao-pre-compra-dolar',
        modelo: 'PRE_COMPRA_USD',
        titulo: 'Pré-Compra (Cotação) - Dólar'
    },
    {
        view: 'impressao-compra-internacional',
        modelo: 'INTERNACIONAL',
        titulo: 'Pré-Compra (Internacional)'
    },
    {
        view: 'impressao-compra-lista',
        modelo: 'LISTA_GERAL',
        titulo: 'Pré-Compra - Lista Geral'
    },
    {
        view: 'impressao-pedido-compra',
        modelo: 'PEDIDO_COMPRA',
        titulo: 'Impressão de Pedido de Compra'
    }
];
export const COLUNAS_ITENS: ColunaCompra[] = [
    {chave: 'seq', titulo: 'Código', padrao: true},
    {chave: 'nunota', titulo: 'Cód. Pré-Compra'},
    {chave: 'codprod', titulo: 'Cód. Peça', padrao: true},
    {chave: 'totalBrl', titulo: 'Subtotal R$', formato: 'valor', padrao: true},
    {
        chave: 'qtd',
        titulo: 'Quantidade',
        ingles: 'Qty',
        formato: 'numero',
        padrao: true
    },
    {chave: 'unitUsd', titulo: 'Valor moeda', formato: 'valor', padrao: true},
    {
        chave: 'unitBrl',
        titulo: 'Valor unit. R$',
        formato: 'valor',
        padrao: true
    },
    {
        chave: 'serial',
        titulo: 'Nº de série',
        ingles: 'Serial no.',
        padrao: true
    },
    {
        chave: 'descricao',
        titulo: 'Descrição',
        ingles: 'Description',
        padrao: true
    },
    {chave: 'entregue', titulo: 'Ent.', formato: 'numero'},
    {chave: 'coreBrl', titulo: 'Valor Core R$', formato: 'valor'},
    {chave: 'core', titulo: 'Core', padrao: true},
    {chave: 'totalUsd', titulo: 'Subtotal moeda', formato: 'valor'},
    {chave: 'coreUsd', titulo: 'Valor Core moeda', formato: 'valor'},
    {chave: 'usuario', titulo: 'Usuário'},
    {chave: 'atualizacao', titulo: 'Cadastro/Atualização'},
    {chave: 'empresa', titulo: 'Empresa'},
    {chave: 'observacao', titulo: 'Descrição do item (Obs.)'},
    {chave: 'desconto', titulo: 'Desconto R$', formato: 'valor'},
    {chave: 'pn', titulo: 'PN', ingles: 'Part Number', padrao: true},
    {chave: 'estoque', titulo: 'Qtde estoque', formato: 'numero'},
    {chave: 'custo', titulo: 'Custo', formato: 'valor'},
    {chave: 'margem', titulo: 'Margem de lucro', formato: 'numero'},
    {chave: 'unidade', titulo: 'Und', ingles: 'Unit', padrao: true},
    {chave: 'ultimoCalculo', titulo: 'Data último cálculo'},
    {chave: 'fabricante', titulo: 'Fabricante', ingles: 'Manufacturer'},
    {chave: 'local', titulo: 'Local'},
    {chave: 'condicao', titulo: 'Condição', ingles: 'CD'},
    {chave: 'status', titulo: 'Status'}
];
export const CAMPOS_CABECALHO: ColunaCompra[] = [
    {chave: 'nunota', titulo: 'Código', padrao: true},
    {chave: 'cliente', titulo: 'Fornecedor'},
    {chave: 'condicaoPagamento', titulo: 'Condição de pagamento'},
    {chave: 'codparc', titulo: 'Cód. Fat.'},
    {chave: 'moeda', titulo: 'Moeda'},
    {chave: 'vendas', titulo: 'Vendas'},
    {chave: 'dtmov', titulo: 'Emissão', padrao: true},
    {chave: 'vlrnota', titulo: 'Total R$', formato: 'valor'},
    {chave: 'gplStatus', titulo: 'Status', padrao: true},
    {chave: 'numTitulo', titulo: 'Nº Título', padrao: true},
    {chave: 'observacao', titulo: 'Descrição'},
    {chave: 'finalizacao', titulo: 'Finalização'},
    {chave: 'finalizador', titulo: 'Func. finalização'},
    {chave: 'numCotacao', titulo: 'Códigos cotações'},
    {chave: 'vlrFrete', titulo: 'Frete local R$', formato: 'valor'},
    {chave: 'freteExterno', titulo: 'Frete estrangeiro R$', formato: 'valor'},
    {chave: 'vlrOutros', titulo: 'Outras despesas locais R$', formato: 'valor'},
    {
        chave: 'despesasExternas',
        titulo: 'Outras despesas estrangeiras R$',
        formato: 'valor'
    },
    {chave: 'total', titulo: 'Total geral R$', formato: 'valor', padrao: true},
    {chave: 'adCategoria', titulo: 'Categoria', padrao: true},
    {chave: 'tipoGpl', titulo: 'Tipo', padrao: true},
    {chave: 'numOrdem', titulo: 'Nº Ordem', padrao: true},
    {chave: 'totalCore', titulo: 'Total Core R$', formato: 'valor'},
    {chave: 'usuario', titulo: 'Usuário'},
    {chave: 'atualizacao', titulo: 'Cadastro/Atualização'},
    {chave: 'solicitacao', titulo: 'Solicitação', padrao: true},
    {chave: 'autorizacaoData', titulo: 'Aut./Canc.', padrao: true},
    {chave: 'autorizadorCodigo', titulo: 'Cód. Aut./Canc.'},
    {chave: 'posicaoParada', titulo: 'Pos. parada'},
    {chave: 'empresa', titulo: 'Empresa', padrao: true},
    {chave: 'solicitanteCodigo', titulo: 'Cód. Sol.'},
    {chave: 'solicitante', titulo: 'Solicitante', padrao: true},
    {chave: 'autorizador', titulo: 'Autorizou', padrao: true},
    {chave: 'inicioVenda', titulo: 'Início venda'},
    {chave: 'terminoVenda', titulo: 'Término venda'},
    {chave: 'prioridade', titulo: 'Prioridade', padrao: true},
    {chave: 'geracao', titulo: 'Geração', padrao: true},
    {chave: 'preVendas', titulo: 'Pré-vendas'},
    {chave: 'descricaoSolicitante', titulo: 'Descrição solicitante'}
];
export function numeroCompra(valor: any): number | null {
    if (valor === null || valor === undefined || valor === '') return null;
    const n = Number(valor);
    return Number.isFinite(n) ? n : null;
}
export function itensCompra(documento: any): ItemImpressaoCompra[] {
    const taxa = numeroCompra(documento.compra?.vlrMoeda ?? documento.VLRMOEDA);
    const usd = (n: number | null) =>
        n !== null && taxa !== null && taxa > 0 ? n / taxa : null;
    return (documento.items ?? []).map((it: any) => {
        const c = it.compra ?? {};
        const qtd = numeroCompra(c.qtd ?? it.QTDNEG);
        const unitBrl = numeroCompra(c.vlrunit ?? it.VLRUNIT);
        const totalBrl = numeroCompra(c.vlrtot ?? it.VLRTOT);
        const controleCore = String(c.controlaCore ?? '').toUpperCase();
        const coreUnitUsd =
            controleCore === 'S'
                ? numeroCompra(c.vlrCore)
                : controleCore === 'N'
                  ? 0
                  : null;
        const coreUsd =
            coreUnitUsd !== null && qtd !== null ? coreUnitUsd * qtd : null;
        return {
            seq: c.seq ?? it.SEQUENCIA,
            nunota: documento.NUNOTA,
            codprod: c.codprod ?? it.CODPROD,
            pn: c.refforn ?? it.REFFORN,
            descricao: c.descricao ?? it.DESCRPROD,
            fabricante: it.FABRICANTE || it.DESCRMAR,
            qtd,
            unidade: c.codvol ?? it.CODVOL,
            unitBrl,
            unitUsd: usd(unitBrl),
            totalBrl,
            totalUsd: usd(totalBrl),
            // O preço salvo já contém o Core: exibimos a parcela informativa sem somá-la novamente.
            core: c.controlaCore ?? it.CORE,
            coreUsd,
            coreBrl:
                coreUsd !== null && taxa !== null && taxa > 0
                    ? coreUsd * taxa
                    : null,
            serial: it.AD_SERIAL || (c.tipContest === 'E' ? c.controle : ''),
            condicao: c.condicao ?? it.AD_CONDICAO,
            local: c.local ?? c.codlocal,
            estoque: c.estoque,
            observacao: c.observacao,
            status: it.GPL_STATUSITEM ?? c.statusItem,
            entregue: it.QTDENTREGUE ?? c.qtdentregue,
            desconto: c.vlrdesc,
            empresa: documento.CODEMP,
            usuario: c.usuario,
            atualizacao: c.atualizacao,
            custo: c.custo,
            margem: c.margem,
            ultimoCalculo: c.ultimoCalculo
        };
    });
}
export function selecionarItensCompra(
    itens: ItemImpressaoCompra[],
    pedido: boolean,
    cancelados: boolean,
    abertos: boolean,
    ordem: string
): ItemImpressaoCompra[] {
    return itens
        .filter((it) => {
            const status = String(it.status ?? '')
                .trim()
                .toUpperCase();
            if (pedido && !cancelados && status === 'CANCELADO') return false;
            if (pedido && abertos && !['ABERTO', 'PARCIAL'].includes(status))
                return false;
            return true;
        })
        .sort((a, b) => {
            const comparacao =
                ordem === 'seq'
                    ? Number(a.seq ?? 0) - Number(b.seq ?? 0)
                    : String(a[ordem] ?? '').localeCompare(
                          String(b[ordem] ?? ''),
                          'pt-BR',
                          {numeric: true, sensitivity: 'base'}
                      );
            return comparacao || Number(a.seq ?? 0) - Number(b.seq ?? 0);
        });
}
